import React, { useEffect } from "react";
import SapToSleep from '../components/OtherPages/SapToSleep'

export default function SapToSleepPage() {
  useEffect(() => {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }, []);
  return (
    <div>
      <SapToSleep/>
    </div>
  )
}